import Vue from 'vue'
import { Component } from 'vue-property-decorator'

import { ApolloResponse } from '@/interfaces/apollo'
import { getCandidateRecordTypes } from '@/modules/RecordType/gql/record-type.gql'
import { RecordType, RecordTypeMaster } from '@/modules/RecordType/interfaces/record-type'
import { showErrors } from '@/utils/snack'

@Component
export default class SearchRecordType extends Vue {
  candidatesRecordType: RecordType[] = []

  get candidatesRecordTypeNameOptions () {
    return this.candidatesRecordType.map(item => {
      return item.name
    })
  }

  get candidatesRecordTypeOptions () {
    return this.candidatesRecordType.map(item => {
      return {
        id: +item.id,
        name: item.name
      }
    })
  }

  async getCandidateRecordTypes (type: RecordTypeMaster) {
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getCandidateRecordTypes,
        variables: {
          masterType: type,
          paging: {
            offset: 0,
            limit: -1
          }
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      this.candidatesRecordType = result.data.getRecordTypes.recordTypes
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }
}
